import { createReducer, on } from '@ngrx/store';
import { driverLicenseActions } from '../driver_license.actions';

export interface DlUploadS3State {
    state: 'pending' | 'loading' | 'loaded' | 'error';
}

export const initialState: DlUploadS3State = { state: 'pending' };

export const dlUploadS3Reducer = createReducer(
    initialState,
    on(driverLicenseActions.uploadS3, (state) => ({ ...state, state: 'loading' as const })),
    on(driverLicenseActions.uploadS3Success, (state) => ({ ...state, state: 'loaded' as const })),
    on(driverLicenseActions.uploadS3Fail, (state) => ({ ...state, state: 'error' as const })),
    on(driverLicenseActions.clearUploadS3, () => initialState)
);
